module.exports = __webpack_public_path__ + "img/编组 15.4579259a.png";